import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import {
    container,
    link,
    name,
    label,
    img,
    lock,
    nameBox,
    selected,
} from './recipe-search-item.module.scss';
import LockIcon from '../../../assets/images/svg/icon-lock.svg';
import { forbiddenClick } from '../../../redux/rbac/rbac.actions';
import { addModalAction } from '../../../redux/actions/actions-modals';
import useRecipeAbsolutePath from '../../../hooks/use-recipe-absolute-path';
import useIsProfileRecipeOwner from '../../../hooks/use-is-profile-recipe-owner';
import { useIsPWA } from '../../../hooks/use-is-pwa';

import Avatar from '../avatar';
import RecipePreviewModal from '../../organisms/custom-modals/recipe-preview-modal';

const RecipeSearchItem = ({ className, recipe, onRecipeSelect, isSelected }) => {
    const dispatch = useDispatch();
    const isOwnedByProfile = useIsProfileRecipeOwner(recipe);
    const recipePath = useRecipeAbsolutePath(recipe);
    const isPWA = useIsPWA();

    const isRestricted = recipe.restrictedFields?.length > 0;

    const handleClick = () => {
        if (isRestricted) {
            dispatch(forbiddenClick());
        } else {
            onRecipeSelect(recipe);
        }
    };

    const handleOpenPreview = () =>
        dispatch(
            addModalAction({
                renderComponent: (modalId) => (
                    <RecipePreviewModal modalId={modalId} recipeId={recipe.id} />
                ),
            })
        );

    return (
        <div className={`${container} ${isSelected ? selected : ''} ${className}`}>
            <button className={nameBox} onClick={handleClick}>
                {isRestricted ? (
                    <div className={lock}>
                        <LockIcon />
                    </div>
                ) : (
                    <Avatar className={img} avatarUri={recipe.coverUri} hasShadow={false} />
                )}
                <span className={name}>
                    {isOwnedByProfile && <span className={label}>Twój przepis</span>}
                    {recipe.name}
                </span>
            </button>
            {!isRestricted &&
                (isPWA ? (
                    <button onClick={handleOpenPreview} className={link}>
                        zobacz <span>przepis</span>
                    </button>
                ) : (
                    <a href={recipePath} target="_blank" rel="noreferrer" className={link}>
                        zobacz <span>przepis</span>
                    </a>
                ))}
        </div>
    );
};

RecipeSearchItem.propTypes = {
    recipe: PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
        coverUri: PropTypes.string,
    }).isRequired,
    className: PropTypes.string,
    onRecipeSelect: PropTypes.func,
    isSelected: PropTypes.bool,
};

RecipeSearchItem.defaultProps = {
    className: '',
    onItemSelect: '',
    onRecipeSelect: () => {},
    isSelected: false,
};

export default RecipeSearchItem;
